module.exports = __webpack_public_path__ + "img/bg-2.81271170.jpg";